import type { User } from "@/shared/generated/graphql";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import type { CustomerBase } from "@/shared/@types/CustomerBase";
import { getCustomerIdsWithAppPermission } from "@/shared/helper/getCustomerIdsWithAppPermission.helper";

export const getInitialSelectedCustomerId = (
  user: User,
  allCustomers: Array<CustomerBase>,
  selectedCustomerId?: string,
  currentApp?: AppIdentifier,
): string | undefined => {
  // If the selected customer ID is valid, return it
  if (allCustomers.some((customer) => customer.id === selectedCustomerId))
    return selectedCustomerId;
  // If the selected customer ID is not valid, determine the initial selection based on app permissions
  const customerIdsWithPermission = getCustomerIdsWithAppPermission(
    user.permissions,
    allCustomers,
    currentApp,
  );
  // Return the first customer ID the user has permission for
  // If none are available, return the first customer ID of allCustomers
  return customerIdsWithPermission[0] ?? allCustomers[0]?.id;
};
